import { render, staticRenderFns } from "./RequiredIcon.vue?vue&type=template&id=3fabff96&scoped=true&"
import script from "./RequiredIcon.vue?vue&type=script&lang=js&"
export * from "./RequiredIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fabff96",
  null
  
)

export default component.exports